import axiosTokenInstance from 'services/api/backoffice';
import { PREPAID, PREPAID_ERROR } from '_models/redux/types';

// Action function
export const getPrepaid = (prepaidId) => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(`/api/prepaid/${prepaidId}`);

    const { data, status } = response || {};

    dispatch({
      type: PREPAID,
      payload: data || {},
      status: status || {},
      method: 'get',
    });
  } catch (e) {
    dispatch({
      type: PREPAID_ERROR,
      payload: e || {},
    });
  }
};
